<div class="p-2">
    <!-- <div class="row d-flex justify-content-center">
        <mat-form-field floatLabel="never" class="tempBtn col-6">
            <input matInput class="body-font-size" placeholder="Search video" [(ngModel)]="searchDeskText"
                (input)="clearFilter()" (keyup.enter)="highlightVideo()">
            <mat-icon matSuffix id="search-icon" class="pointer" *ngIf="searchDeskText"
                (click)="clearSearchField()">close
            </mat-icon>
            <mat-icon matSuffix id="search-icon" class="pointer">search</mat-icon>
        </mat-form-field>
    </div> -->
    <!-- <header [ngStyle]="{'height':'70px', 'display':'flex', 'align-items':'center', 'padding':'10px'}">
        <img src="./../../../assets/Agora logo.png" alt="" [ngStyle]="{'width':'170px', 'height':'50px'}">
        <button mat-raised-button color="primary" class="fxt-btn-fill text-uppercase" *ngIf="show" [ngStyle]="{'position':'absolute', 'top':'15px', 'right':'15px'}" routerLink="/">Login</button>
    </header> -->
    <nav mat-raised class="header-container-main container-fluid d-flex justify-content-between" style="background: #ffffff;
    border-bottom: 1.5px solid #b4abab;padding: 5px 10px;" *ngIf="show" >
        <img src="assets/Agora logo.png" alt="" [ngStyle]="{'width':'170px', 'height':'50px'}">
        <button mat-raised-button color="primary" class="fxt-btn-fill text-uppercase" [ngStyle]="{'position':'absolute', 'top':'15px', 'right':'15px'}" routerLink="/">Login</button>
    </nav>
    <ng-scrollbar class="global-container d-flex flex-wrap" appearance="compact" #scrollable pointerEventsMethod="scrollbar">
        <div class="col-12 col-sm-12 col-md-12 column">
            <div class="d-flex justify-content-center bx-shadow">
                <mat-form-field floatLabel="auto" class="tempBtn col-11">
                    <input matInput class="body-font-size" placeholder="Search video" [(ngModel)]="searchDeskText"
                        (input)="clearFilter()" (keyup)="highlightVideo()">
                    <mat-icon matSuffix id="search-icon" class="pointer" *ngIf="searchDeskText"
                        (click)="clearSearchField()">close
                    </mat-icon>
                    <mat-icon matSuffix id="search-icon" class="pointer" (click)="highlightVideo()">search</mat-icon>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 video-wrapper">
                <ng-container *ngIf="filterVideos.length == 0 && !isSearched">
                    <cdk-accordion class="example-accordion col-12" multi>
                        <cdk-accordion-item *ngFor="let item of treeViewData; let accordionIndex = index"
                            #accordionItem="cdkAccordionItem" class="example-accordion-item" role="button" tabindex="0"
                            [attr.id]="'accordion-header-' + accordionIndex" [attr.aria-expanded]="accordionItem.expanded"
                            [attr.aria-controls]="'accordion-body-' + accordionIndex" (opened)="onAccordionOpened(accordionIndex)">
                            <div id = "inner-item{{accordionIndex}}" class="example-accordion-item-header d-flex align-items-center"
                                (click)="accordionItem.toggle()">
                                <h2 class="margin-0">{{ item.name }}</h2>
                                <span class="example-accordion-item-description">
                                    <mat-icon class="cmmn-icn-color">{{ accordionItem.expanded ? 'close' :
                                        'add_circle_outline' }}</mat-icon>
                                </span>
                            </div>
                            <div class="example-accordion-item-body" role="region"
                                [style.display]="accordionItem.expanded ? '' : 'none'" [attr.id]="'accordion-body-' + accordionIndex"
                                [attr.aria-labelledby]="'accordion-header-' + accordionIndex">
                                <mat-list role="list">
                                    <ng-container *ngFor="let data of item.data; let i = index">
                                        <mat-list-item role="listitem" class="pd-tb-8" [class.selected]="selectedMenu == data.id">
                                            <div class="d-flex align-items-start">
                                                <div>
                                                    <mat-icon class="d-flex align-items-center icn-size pointer pointer"
                                                        (click)="openVideoDialog(data, i)">play_circle_outline</mat-icon>
                                                </div>
                                                <div>
                                                    <a (click)="openVideoDialog(data, i)" id = "link{{i}}" class="pointer">{{data.name}}</a>
                                                </div>
                                            </div>
                                        </mat-list-item>
                                    </ng-container>
                                </mat-list>
                            </div>
                        </cdk-accordion-item>
                    </cdk-accordion>
                    <!-- <mat-card *ngFor = "let item of treeViewData; let i = index" class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 mat-card-wrapper">
                            <mat-card-header class="mat-header-bx-sh">
                                <h2>{{item.name}}</h2>
                            </mat-card-header>
                            <mat-card-content class="card-ctnt-scrl">
                                <mat-list role="list">
                                    <ng-container *ngFor = "let data of item.data; let i = index">
                                        <mat-list-item role="listitem" class="pd-tb-8">
                                            <div class="d-flex align-items-start">
                                                <div>
                                                    <mat-icon class="d-flex align-items-center icn-size pointer pointer" (click)="openVideoDialog(data)">play_circle_outline</mat-icon>
                                                </div>
                                                <div>
                                                    <a (click)="openVideoDialog(data)" class="pointer">{{data.name}}</a>
                                                </div>
                                            </div>
                                        </mat-list-item>
                                    </ng-container>
                                  </mat-list>
                            </mat-card-content>
                        </mat-card> -->
                </ng-container>
                <ng-container *ngIf="filterVideos.length != 0">
                    <mat-card appearance="outlined" class="col mat-card-wrapper">
                        <mat-card-header class="mat-header-bx-sh">
                            <h2 class="p-r-15">Search results for '<b>{{searchDeskText}}</b>'</h2>
                        </mat-card-header>
                        <mat-card-content class="card-ctnt-scrl-srch">
                            <mat-list role="list">
                                <ng-container *ngFor="let data of filterVideos; let i = index">
                                    <mat-list-item role="listitem" class="pd-tb-8">
                                        <div class="d-flex align-items-start">
                                            <div>
                                                <mat-icon class="d-flex align-items-center icn-size pointer pointer"
                                                    (click)="openSearchVideoDialog(data)">play_circle_outline</mat-icon>
                                            </div>
                                            <div>
                                                <a (click)="openSearchVideoDialog(data)" class="pointer">{{data.name}}</a>
                                            </div>
                                        </div>
                                    </mat-list-item>
                                </ng-container>
                            </mat-list>
                        </mat-card-content>
                    </mat-card>
                </ng-container>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 d-flex align-items-start">
            <h1 *ngIf="filterVideos.length == 0 && isSearched" class="no-video">No video found!</h1>
            <ng-container *ngIf="videoData; else plain">
                <div *ngIf="filterVideos.length != 0 || !isSearched ">
                    <div class="inner-header">
                        <h2 class="p-2 text-center fw-bold">{{videoData.name}}</h2>
                    </div>
                    <div class="mt-5">
                        <app-html-video-tag [videoData]='videoData'></app-html-video-tag>
                    </div>
                </div>
            </ng-container>
            <ng-template #plain>
                <!-- <div class=" col-12 d-flex align-items-center justify-content-center">
                    <div>
                        <img src="assets/play-video.png" alt="play-video" />
                    </div>
                    <h2>Click on video link to load</h2>
                </div> -->
            </ng-template>
            <!-- <video controls class="col-12 p-2" *ngIf = "videoPath">
                    <source src="assets/Agora-Help-Video/{{videoPath}}" type="video/mp4">
                    Your browser does not support the video tag.
                </video> -->
        </div>

    </ng-scrollbar>
</div>
